import { Box, HStack, Text, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import {
  DetailsSkeleton,
  StatusSkeleton,
  TextSkeleton,
} from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { FixedFeeRelatedTermLoading } from '../FixedFeeRelatedTermLoading';

const DetailRow: React.FC<{ label: string }> = ({ label }) => {
  return (
    <HStack justifyContent="space-between" alignItems="center" space="inline.nano">
      <Text>{label}</Text>
      <TextSkeleton w="1/4" />
    </HStack>
  );
};

export const FixedFeeTermDetailsLoadingMobile: React.FC = () => {
  return (
    <VStack
      px="inline.xxxs"
      pb="inline.xxxs"
      bg="neutral.white"
      borderTopRadius="md"
      space="stack.xxxs">
      <HStack justifyContent="space-between" alignItems="flex-start" space="inline.nano">
        <VStack space="inline.quarck" flex={1}>
          <HStack space="inline.quarck" alignItems="center">
            <TextSkeleton w="2/3" />
          </HStack>

          <DetailsSkeleton />
        </VStack>
        <DetailsSkeleton />
      </HStack>

      <HStack space="inline.quarck" justifyContent="space-between" alignItems="center">
        <TextSkeleton w="1/2" />
        <TextSkeleton w="1/4" />
      </HStack>

      <VStack space="stack.nano">
        <DetailRow label="Data de criação" />
        <Box h="1px" bg="neutral.lightest" />
        <DetailRow label="Taxa (%)" />
        <Box h="1px" bg="neutral.lightest" />
        <DetailRow label="Exclusão de taxa" />
        <Box h="1px" bg="neutral.lightest" />
        <DetailRow label="Data de contratação" />
        <Box h="1px" bg="neutral.lightest" />
        <DetailRow label="Patrimônio líquido" />
      </VStack>

      <Box
        h="1px"
        bg={Utils.ColorToken.WithOpacity('brand.primary.principal', 'opacity.semitransparent')}
      />

      <VStack space="stack.xxxs">
        <VStack space="stack.quarck">
          <Text color="neutral.medium" fontSize="xs">
            Última atualização do canal
          </Text>
          <StatusSkeleton />
        </VStack>

        <TextSkeleton w="1/3" />

        <VStack space="stack.quarck">
          <Text color="neutral.medium" fontSize="xs">
            Evento
          </Text>
          <TextSkeleton w="1/3" />
        </VStack>
      </VStack>

      <FixedFeeRelatedTermLoading />
    </VStack>
  );
};
